import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../top/components/Footer';
import registration from '../api/registration';
import RegistrationParams from '../types/RegistrationParams';
import Facility from '../../shared/types/Facility';
import getFacility from '../../shared/api/getFacility';
import AlertMessages from '@/components/AlertMessages';

const RegisterForm: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>("")
  const [alertMessageOpen, setAlertMessageOpen] = useState<boolean>(false)
  const [alertMessages, setAlertMessages] = useState<string[]>([]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const params: RegistrationParams = {
      email: email,
      password: password,
      password_confirmation: passwordConfirmation
    }

    try {
      await registration(params);
      setAlertMessageOpen(false)
      navigate('/facility/top');
    } catch (err: any) {
      setAlertMessageOpen(true);
      if (err.response && err.response.data && err.response.data.errors) {
        setAlertMessageOpen(true);
        setAlertMessages(err.response.data.errors.fullMessages);
      } else {
        setAlertMessageOpen(false);
        console.log('An unexpected error occurred:', err);
      }
    }
  }

  const [facility, setFacility] = useState<Facility | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const facilityData = await getFacility();
        setFacility(facilityData.data.facility);
      } catch (error) {
        console.error("Error fetching facility data:", error);
      }
    };
    
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <main id="page-facility_login" className="wrapper">
        <section className="sec-contact">
          <div className="inner">
            <h1 className="c-ttl__01">施設情報設定</h1>
            <AlertMessages open={alertMessageOpen} messages={alertMessages} />
            <div className="contact-box">
              <div className="contact-box__left">
                <div className="mbpc-98 mbsp-32">
                  <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '0px' }} className="contact-box__form js-item">
                      <div className="contact-box__item">
                        <label className="contact-box__ttl" htmlFor="email">
                          <span>メールアドレス</span>
                          <small>必須</small>
                        </label>
                        <div className="contact-box__ct">
                          <input
                            type="email"
                            className="input"
                            id="email"
                            placeholder="test@example.com"
                            onChange={event => setEmail(event.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="contact-box__item">
                      <label className="contact-box__ttl" htmlFor="password">
                        <span>パスワード</span>
                        <small>必須</small>
                      </label>
                      <div className="contact-box__ct">
                        <input
                          type="password"
                          className="input input--pw"
                          id="password"
                          placeholder="*********"
                          onChange={event => setPassword(event.target.value)}
                        />
                      </div>
                    </div>
                    <div className="contact-box__item mbpc-20 mbsp-20">
                      <label className="contact-box__ttl" htmlFor="password_confirmation">
                        <span>パスワード確認</span>
                        <small>必須</small>
                      </label>
                      <div className="contact-box__ct">
                        <input
                          type="password"
                          className="input input--pw"
                          id="password_confirmation"
                          placeholder="*********"
                          onChange={event => setPasswordConfirmation(event.target.value)}
                        />
                      </div>
                    </div>
                    <p className="c-ttl__02"><span>※パスワードは半角数字、半角記号、半角英大文字、半角英小文字から3種類以上を含む8文字以上で入力してください。</span></p>
                    <div className="contact-box__form js-item" id="id-01">
                      <div className="contact-box__item">
                        <label className="contact-box__ttl">
                          <span>施設名</span>
                        </label>
                        <div className="contact-box__ct">
                          <p className="contact-box__desc">{facility?.name}</p>
                        </div>
                      </div>
                      <div className="contact-box__item">
                        <label className="contact-box__ttl">
                          <span>住所</span>
                        </label>
                        <div className="contact-box__ct">
                          <p className="contact-box__desc">{`${facility?.address1}${facility?.address2 ?? ''}`}</p>
                        </div>
                      </div>
                      <div className="contact-box__item">
                        <label className="contact-box__ttl">
                          <span>電話番号</span>
                        </label>
                        <div className="contact-box__ct">
                          <p className="contact-box__desc">{facility?.phone}</p>
                        </div>
                      </div>
                      <div className="contact-box__item">
                        <label className="contact-box__ttl">
                          <span>Fax番号</span>
                        </label>
                        <div className="contact-box__ct">
                          <p className="contact-box__desc">{facility?.fax}</p>
                        </div>
                      </div>
                      <div className="contact-box__item mbpc-20 mbsp-20">
                        <label className="contact-box__ttl">
                          <span>担当者名</span>
                        </label>
                        <div className="contact-box__ct">
                          <p className="contact-box__desc">{facility?.representativeName}</p>
                        </div>
                      </div>
                      <p className="c-ttl__02"><span>※施設基本情報の変更は弊社担当営業へお申し出ください。</span></p>
                    </div>
                    <button type="submit" className="c-btn__01">登録</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </React.Fragment>
  )
}

export default RegisterForm;

